import { request } from 'sonata-react-components';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';

type DataSegmentSettings = {
  campaignIds?: string[];
  categories: string[];
  countries: string[];
  enabled: boolean;
  eventTypes?: string[];
  name: string;
  owner: string | null;
  price: Record<string, number>;
  providers: string[];
  s3Paths?: string[];
  status: 'approved';
  type: 'user-file' | 'campaign-events' | 'campaign-forecasting' | 'campaign-forecasting-from-prev-campaign';
  user: string;
};

export function getAudienceSegments(token: Record<string, any>, user: Record<string, any>, segmentsIds?: string[]) {
  const data: Record<string, any> = {
    filterEnabled: true,
    sortBy: 'name'
  };
  if (segmentsIds?.length) {
    data.filterSegmentIds = segmentsIds;
  }
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}audienceSegments/${user.id}`,
    {
      data,
      method: 'POST'
    },
    token
  );
}

export function postDataSegment(settings: DataSegmentSettings, token: Record<string, any>) {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}dataSegment`,
    {
      data: settings,
      method: 'POST'
    },
    token
  );
}

export function getAudienceMappings(token: Record<string, any>) {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}audienceMappings`,
    {
      method: 'GET'
    },
    token
  );
}

export function getVenuesByIds(venues: string[], userId: string | undefined, token: Record<string, any>) {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}shops/${userId}/byIds`,
    {
      data: {
        shops: venues
      },
      method: 'POST'
    },
    token
  );
}

export function createAssociatedForecastingCampaign(
  name: string | undefined,
  radius: number,
  venues: string[],
  userId: string | undefined,
  token: Record<string, any>
) {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}campaignForAudience/${userId}`,
    {
      data: {
        name,
        radius,
        venues
      },
      method: 'POST'
    },
    token
  );
}

export type RetargetingCampaign = {
  _id: string;
  events: string[];
  name: string;
  userName?: string;
};

export type RetargetingCampaignsResponse = {
  items: RetargetingCampaign[];
  totalItems: number;
};

export function getRetargetingCampaigns(
  token: Record<string, any>,
  user: Record<string, any>,
  filterString: string
): Promise<RetargetingCampaignsResponse> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}campaigns/${user._id}/audienceBuilder`,
    {
      data: {
        eventsScope: 'retargeting',
        filterCompleted: true,
        filterForecasting: false,
        filterString,
        limit: 10,
        order: 'desc',
        page: 1,
        sortBy: 'modified'
      },
      method: 'POST'
    },
    token
  );
}

export type DeviceIdsImportFileResponse = {
  fileUrl: string;
  filePath: string;
  totalLines: number;
};

export function deviceIdsImportFile(
  token: Record<string, any>,
  user: UserInterface<string>,
  file: File
): Promise<DeviceIdsImportFileResponse> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}batch/import/deviceId/file/${user.id}/segment/${new Date().getTime()}`,
    {
      data: new Blob([file]),
      headers: {
        'Content-Type': 'text/csv',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST'
    },
    token
  );
}
